import React from 'react';
import ErrorPage from './ErrorPage.js';

const ServerError = () => (
  <ErrorPage
    code="500"
    title="Internal Server Error"
    message="Something went wrong on our end. Please try again later."
  />
);

export default ServerError;
